import { Box, ListItem, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { resolveDisplayedFindingTitle } from "./change-source-citation-presenters"

export function ChangeSourceCitationListItem({ item }) {
    const title = item.sourceDocumentReference || item.sourceDocumentTitle || item.sourceTypeLabel || "Source"
    const pageLabel = formatPages(item.pageRefs)
    const findingTitle = resolveDisplayedFindingTitle(item)

    return (
        <ListItem disablePadding sx={{ py: 0.5 }}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "minmax(180px, 220px) minmax(0, 1fr)",
                        md: "minmax(220px, 280px) minmax(0, 1fr)",
                    },
                    columnGap: 2,
                    rowGap: 0.25,
                    alignItems: "start",
                    width: "100%",
                }}
            >
                <Typography variant="body2" fontWeight="medium" sx={{ minWidth: 0 }}>
                    {title}
                    <If truthy={pageLabel}> {pageLabel}</If>
                </Typography>
                <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                    <If truthy={findingTitle}>
                        <Typography variant="caption" color="text.secondary">
                            {findingTitle}
                        </Typography>
                    </If>
                    <If truthy={item.findingText}>
                        <Typography variant="caption" color="text.secondary">
                            {item.findingText}
                        </Typography>
                    </If>
                </Stack>
            </Box>
        </ListItem>
    )
}

function formatPages(pageRefs) {
    const pages = Array.isArray(pageRefs) ? pageRefs.filter(Boolean) : []
    if (!pages.length) return ""
    return `[Page ${pages.join(",")}]`
}
